module.exports = __webpack_public_path__ + "static/Trend-watch-UX-design-trends-2023-ff8aeba0819c767eac74869b052e5876.png";